import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useCallback } from 'react';
import cn from 'classnames';
import { useBiAction } from '../BiTracking';
import { Typography } from '../Typography';
import classes from './NumberedListOption.module.scss';
export const NumberedListOption = /*#__PURE__*/ forwardRef(function NumberedListOption(props, ref) {
    const { className, number, label, selected, disabled, testId, bi, noBi: _noBi, onClick } = props, rest = _object_without_properties(props, [
        "className",
        "number",
        "label",
        "selected",
        "disabled",
        "testId",
        "bi",
        "noBi",
        "onClick"
    ]);
    const logBiAction = useBiAction();
    const handleClick = useCallback((event)=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'numbered_list_option',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        return onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        bi,
        logBiAction,
        onClick,
        testId
    ]);
    return /*#__PURE__*/ _jsxs("button", _object_spread_props(_object_spread({
        type: "button",
        ref: ref,
        disabled: disabled,
        "data-testid": testId,
        className: cn(classes.root, className, {
            [classes.selected]: selected
        }),
        onClick: handleClick
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                className: classes.badge,
                testId: testId != null ? "".concat(testId, "-badge") : undefined,
                children: number
            }),
            /*#__PURE__*/ _jsx(Typography, {
                className: classes.label,
                testId: testId != null ? "".concat(testId, "-label") : undefined,
                children: label
            })
        ]
    }));
});
